import React, { Component } from "react";
import withStyles from "@material-ui/styles/withStyles";
import { withRouter } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Topbar from "../components/TopbarGarnet";
import FooterGarnet from "../components/FooterGarnet";
import Typography from '@material-ui/core/Typography';
import API from "../api/axios";
import Loading from "../components/common/Loading";

const queryString = require("query-string");

const fondoImagenUrl = require("../images/productos_apple.png");
const iconoCentral = require("../images/icono_central.png");

const styles = theme => ({
    tituloPrincipal1: {
        fontFamily: "Source Sans Pro",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "48px",
        lineHeight: "53px",
        color: "#0087C2",
        marginBottom: "1rem"
    },
    tituloPrincipal2: {
        fontFamily: "Source Sans Pro",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "32px",
        lineHeight: "53px",
        color: "#0087C2",
        marginBottom: "3rem"
    },
    textoDetalle: {
        fontFamily: "Source Sans Pro",
        fontStyle: "normal",
        fontWeight: "400",
        fontSize: "24px",
        lineHeight: "26px",
        color: "#474747",
        marginBottom: "1.5rem"
    },
    iconoCentral: {
        width: '200px',
        marginLeft: '-100px',
        [theme.breakpoints.down("sm")]: {
            display: "none"
        }
    },
    fondoImagen: {
        background: `url(${fondoImagenUrl}) no-repeat`,
        backgroundSize: "cover",
        height: '960px',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        [theme.breakpoints.down("sm")]: {
            height: "100vh",
            display: "block",
            position: "fixed",
            top: 0,
            width: "100%",
            backgroundPosition: "center",
        }
    },
    containerTab: {
        padding: "10px 7rem 10px 5rem", 
        display: "flex", 
        flexDirection: "column", 
        alignItems: "flex-start",
        [theme.breakpoints.down("sm")]: {
            padding: "10px 1rem 10px 1rem", 
            height: "initial",
            overflow: "initial",
            overflowX: "initial",
            backgroundColor: "rgba(255,255,255,0.8)",
            position: "relative",
            zIndex: "1",
            minHeight: "calc(100vh - 160px)",
        }
    }
})

class LandingLoading extends Component{
    constructor(props){
        super(props);
        this.state = {
            loading: true

        }
    }
    toRetry(){

    }
    componentDidMount(){
        // console.log(window.location.hash);
        // var values = queryString.parse(window.location.hash);
        // console.log(values);

        var newUrl = window.location.hash.replaceAll("/landing-loading?", "");
        var values = queryString.parse(newUrl);
        console.log(values);
        
        if (values.token) {
            API({
              url: "api/landing/mtek/checkout/confirm",
              method: "POST",
              data: { token: values.token },
            })
              .then((response) => {
                console.log(response);
                window.location.href = response.data;
                // setTimeout(() => {
                //     window.location.href = response;
                //   }, 1500);

              })
              .catch((e) => {
                console.log(e);
                const mensajesError = [
                  {
                    active: true,
                    message:
                      "Lo sentimos, tenemos un error interno. Intente de nuevo mas tarde.",
                  },
                ];
                this.setState({ mensajesError });
              });
          } else {
            console.log('ddddd');
            window.location.href = '/#/landing-error';

          }


    }
    render(){
        const { classes } = this.props;
        return (
            <>
            <Loading loading={this.state.loading} />
                <Topbar />
                    <Grid container spacing={0}>
                        <Grid  item xs={12} sm={12} md={6}>
                            <div className={classes.containerTab}>
                                <Typography style={{marginTop: "2rem"}} className={classes.tituloPrincipal1}>
                                    Estamos procesando tu compra!
                                </Typography>
                                <Typography className={classes.tituloPrincipal2}>
                                Espera unos segundos y serás redirigido al resultado.
                                </Typography>
                                <Typography  className={classes.textoDetalle}>
                                    
                                    <br></br>
                                </Typography>
                            </div>
                        </Grid>
                        <Grid className={classes.fondoImagen } item xs={12} sm={12} md={6}>
                            <img className={classes.iconoCentral} src={iconoCentral} alt="icono"></img>
                        </Grid>
                    </Grid>
                <FooterGarnet />
            </>
        );
    }
}

export default withRouter(withStyles(styles)(LandingLoading));
